import { createContext } from 'react';

import { TimeseriesPerVariant } from '../types/timeseries.js';

export type TimeseriesRawDataPerVariant = Omit<
  TimeseriesPerVariant,
  'shapePriority'
>;

export const TimeseriesRawDataContext =
  createContext<TimeseriesRawDataPerVariant>({
    area: [],
    band: [],
    bar: [],
    line: [],
  });
